import { memo } from 'react';
import cn from 'classnames';
import MulticolouredIcon from './assets/multicoloured.react.svg';
import TransparentIcon from './assets/transparent.react.svg';
import { makeModifierClassname } from '../../lib/makeModifierClassname';
import styles from './ColorDot.module.css';

export interface ColorDotProps {
    /** Цвет круга */
    color: string;
    /** Размер круга */
    size?: 'sm' | 'md';
    /** Дополнительные CSS классы */
    className?: string;
    /** Показать границу */
    showBorder?: boolean;
}

const colorDotModifier = makeModifierClassname(styles, 'colorDot');

export const ColorDot = memo(function ColorDot({ color, size = 'md', className, showBorder = true }: ColorDotProps) {
    const commonClasses = cn(
        colorDotModifier.className,
        colorDotModifier('size', size),
        colorDotModifier('withBorder', showBorder),
        className
    );

    const renderContent = () => {
        switch (color) {
            case 'multicoloured':
                return <MulticolouredIcon />;
            case 'transparent':
                return <TransparentIcon />;

            default:
                return null;
        }
    };

    const style = color !== 'multicoloured' && color !== 'transparent' ? { backgroundColor: color } : undefined;

    return (
        <div className={commonClasses} style={style}>
            {renderContent()}
        </div>
    );
});
